import { render, staticRenderFns } from "./AddonsList.vue?vue&type=template&id=aaab9fb4&"
import script from "./AddonsList.vue?vue&type=script&lang=js&"
export * from "./AddonsList.vue?vue&type=script&lang=js&"
import style0 from "./AddonsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports